// extracted by mini-css-extract-plugin
export default {"body":"MessageModal_body__4BVR3","action":"MessageModal_action__rZdjY"};